(function () {
  const config = window.geekoEmailUnsubscribeConfig || {};
  const strings = config.strings || {};
  const GENERIC_ERROR =
    strings.error_generic || 'Something went wrong. Please try again later.';

  const form = document.getElementById('GeekoEmailUnsubscribeForm');
  const input = document.getElementById('GeekoEmailUnsubscribeInput');
  const successEl = document.querySelector('.geeko-email-unsubscribe__success');
  const errorEl = document.querySelector('.geeko-email-unsubscribe__error');

  if (!form || !input) return;

  const params = new URLSearchParams(window.location.search);
  const emailFromUrl = params.get('email') || config.prefilledEmail || '';

  if (emailFromUrl) {
    try {
      input.value = decodeURIComponent(String(emailFromUrl).replace(/\+/g, ' '));
    } catch (_) {
      input.value = emailFromUrl;
    }
    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.classList.add('geeko-email-unsubscribe__input--locked');
  }

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const MAX_USER_ERROR_LENGTH = 280;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    hideError();

    const email = input.value.trim();
    if (!EMAIL_RE.test(email)) {
      showError(strings.error_invalid_email || 'Please enter a valid email address.');
      return;
    }

    const btn = form.querySelector('[type="submit"]');
    const spinner = btn?.querySelector('.loading-overlay__spinner');
    btn.disabled = true;
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const base = (config.apiEndpoint || 'https://www.app.chicme.com/unsubscribe').replace(/\/$/, '');
      const sep = base.includes('?') ? '&' : '?';
      const url = base + sep + 'email=' + encodeURIComponent(email);

      const res = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json, text/plain, */*' },
      });

      const contentType = (res.headers.get('content-type') || '').toLowerCase();
      const bodyText = await res.text();

      if (contentType.includes('text/html') || isHtmlLike(bodyText)) {
        throw new Error(GENERIC_ERROR);
      }

      if (!res.ok) {
        throw new Error(toUserErrorMessage(bodyText, res.status));
      }

      let json = null;
      if (bodyText.trim()) {
        try {
          json = JSON.parse(bodyText);
        } catch (_) {
          if (!isSafePlainText(bodyText)) {
            throw new Error(GENERIC_ERROR);
          }
        }
      }

      if (json && json.success === false) {
        throw new Error(toUserErrorMessage(json.message, res.status));
      }

      form.classList.add('hidden');
      if (successEl) {
        successEl.classList.remove('hidden');
        successEl.setAttribute('tabindex', '-1');
        successEl.focus();
      }
    } catch (err) {
      showError(toUserErrorMessage(err && err.message));
      btn.disabled = false;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  });

  function isHtmlLike(text) {
    const sample = String(text || '')
      .trim()
      .slice(0, 200)
      .toLowerCase();
    return (
      sample.startsWith('<!doctype') ||
      sample.startsWith('<html') ||
      sample.startsWith('<') ||
      sample.includes('<head') ||
      sample.includes('<body')
    );
  }

  function isSafePlainText(text) {
    const t = String(text || '').trim();
    if (!t || isHtmlLike(t)) return false;
    if (t.length > MAX_USER_ERROR_LENGTH) return false;
    return true;
  }

  function toUserErrorMessage(raw, status) {
    const msg = String(raw || '').trim();
    if (!msg || isHtmlLike(msg) || msg.length > MAX_USER_ERROR_LENGTH) {
      return GENERIC_ERROR;
    }
    if (status === 404 || status === 502 || status === 503) {
      return GENERIC_ERROR;
    }
    return msg;
  }

  function showError(msg) {
    if (!errorEl) return;
    const safeMsg = toUserErrorMessage(msg);
    errorEl.innerHTML =
      '<div class="form__message" role="alert">' +
      '<span class="visually-hidden">Error</span>' +
      '<span>' +
      escapeHtml(safeMsg) +
      '</span></div>';
    errorEl.classList.remove('hidden');
    errorEl.focus();
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.innerHTML = '';
    errorEl.classList.add('hidden');
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
})();
